import React from "react";

const CreditLimitCardSkeleton = () => {
  return (
    <div className="space-y-4 bg-gray-50 p-4 border-l-4 border-gray-300 border rounded-xl shadow-sm ">
      {/* Top badges */}
      <div className="flex justify-between items-center">
        <div className="h-5 w-24 bg-gray-300 rounded-full" />
        <div className="h-5 w-20 bg-gray-300 rounded-full" />
      </div>

      {/* Instructional Message */}
      <div className="bg-gray-200 p-3 rounded-md text-center">
        {/* <div className="h-4 w-3/4 mx-auto bg-gray-300 rounded" /> */}
        <p className=" text-sm text-gray-500">Choose a customer to view credit limit details.</p>{" "}
      </div>

      {/* Credit Limit Summary */}
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 bg-gray-300 rounded-full" />
            <div className="h-4 w-20 bg-gray-300 rounded" />
          </div>
          <div className="h-5 w-24 bg-gray-300 rounded" />
        </div>

        {/* Progress Bar */}
        <div className="space-y-2">
          {/* <div className="flex justify-between text-xs">
            <div className="h-3 w-20 bg-gray-300 rounded" />
            <div className="h-3 w-24 bg-gray-300 rounded" />
          </div> */}

          <div className="w-full h-3 bg-gray-300 rounded-full">
            <div className="h-full w-1/2 bg-gray-400 rounded-full" />
          </div>

          <div className="flex justify-between items-center text-xs">
            <div className="h-3 w-16 bg-gray-300 rounded" />
            <div className="flex items-center gap-2">
              <div className="h-3 w-3 bg-gray-300 rounded-full" />
              <div className="h-3 w-20 bg-gray-300 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditLimitCardSkeleton;
